const normalizeDate = (value) => {
    if (!value) return '';
    return String(value).slice(0, 10);
};

export const hasPrepDate = (prescription, searchDate) => {
    const targetDate = normalizeDate(searchDate);
    if (!targetDate) return false;

    return (prescription?.dates || []).some((date) => (
        normalizeDate(date?.formated_date || date?.date) === targetDate
    ));
};

/**
 * Preserve the existing same-day rule while allowing an active prescription
 * that the API explicitly calculated for the selected date. This prevents a
 * valid daily RX from being silently omitted when PREVDATE is stale.
 */
export const isBulkPrepEligible = (prescription, searchDate) => {
    if (!prescription) return false;

    if (prescription.days_difference === 0) return true;

    return prescription.can_prep_check !== false
        && prescription.is_logged_prep !== false
        && hasPrepDate(prescription, searchDate);
};

export const getBulkPrepEligiblePrescriptions = (prescriptions = [], searchDate) => (
    prescriptions.filter((prescription) => isBulkPrepEligible(prescription, searchDate))
);

export const getBulkPrepCompletionState = (prescriptions = [], searchDate) => {
    const eligibleDates = getBulkPrepEligiblePrescriptions(prescriptions, searchDate)
        .flatMap((prescription) => prescription?.dates || []);
    const total = eligibleDates.length;
    const completed = eligibleDates.filter((date) => date?.is_checked === true).length;

    let state = 'pending';
    if (total === 0) state = 'none';
    else if (completed === total) state = 'complete';
    else if (completed > 0) state = 'partial';

    return {
        state,
        total,
        completed,
        pending: Math.max(total - completed, 0)
    };
};
